import { useState } from "react";
import { Link } from "react-router-dom";
import { Shield, MailCheck, ArrowLeft } from "lucide-react";
import { api, formatErr } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault(); setLoading(true); setError("");
    try { await api.post("/auth/forgot-password", { email }); setSent(true); }
    catch (e) { setError(formatErr(e.response?.data?.detail) || e.message); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-cream flex items-center justify-center px-6 py-12">
      <div className="w-full max-w-md" data-testid="forgot-password-page">
        <Link to="/" className="inline-flex items-center gap-2 text-ink"><Shield className="w-5 h-5" strokeWidth={1.5} /><span className="font-serif text-xl">Withdraw Guard</span></Link>
        <h1 className="font-serif text-4xl sm:text-5xl tracking-tight mt-10">Forgot your password?</h1>
        <p className="text-moss mt-3">Enter your email and we&apos;ll send a one-time link to choose a new one.</p>

        {sent ? (
          <div className="mt-10 bg-linen border border-sand rounded-2xl p-6" data-testid="forgot-password-sent">
            <MailCheck className="w-6 h-6 text-forest" strokeWidth={1.5} />
            <h2 className="font-serif text-2xl mt-3">Check your inbox.</h2>
            <p className="text-sm text-moss mt-2">If <strong className="text-ink">{email}</strong> has an account, a reset link is on its way. It works once and expires in 30 minutes.</p>
            <Link to="/login" className="mt-6 inline-flex items-center gap-1.5 text-sm text-forest font-medium" data-testid="forgot-password-back"><ArrowLeft className="w-4 h-4" /> Back to sign in</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-10 space-y-5" data-testid="forgot-password-form">
            <div>
              <label className="text-xs uppercase tracking-[0.2em] font-semibold text-sage">Email</label>
              <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} autoFocus
                className="mt-2 w-full bg-cream border border-sand rounded-lg px-4 py-3 focus:ring-2 focus:ring-forest focus:border-transparent outline-none"
                data-testid="forgot-password-email" />
            </div>
            {error && <div className="text-sm text-clay bg-clay-light px-4 py-3 rounded-lg" data-testid="forgot-password-error">{error}</div>}
            <button type="submit" disabled={loading}
              className="w-full bg-forest text-white rounded-lg px-6 py-3.5 font-medium hover:bg-forest-deep disabled:opacity-60 transition-colors"
              data-testid="forgot-password-submit">
              {loading ? "Sending…" : "Send reset link"}
            </button>
            <Link to="/login" className="inline-flex items-center gap-1.5 text-sm text-moss hover:text-ink" data-testid="forgot-password-cancel"><ArrowLeft className="w-4 h-4" /> Back to sign in</Link>
          </form>
        )}
      </div>
    </div>
  );
}
